export default Object.freeze({
  Percent: 1,
  FixedAmount: 2,
});
